import { render, staticRenderFns } from "./EmployeeSwiftCodeField.vue?vue&type=template&id=4d3a3b04&scoped=true&"
import script from "./EmployeeSwiftCodeField.vue?vue&type=script&lang=js&"
export * from "./EmployeeSwiftCodeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3a3b04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d3a3b04')) {
      api.createRecord('4d3a3b04', component.options)
    } else {
      api.reload('4d3a3b04', component.options)
    }
    module.hot.accept("./EmployeeSwiftCodeField.vue?vue&type=template&id=4d3a3b04&scoped=true&", function () {
      api.rerender('4d3a3b04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/fields/EmployeeSwiftCodeField.vue"
export default component.exports